module.exports = __webpack_public_path__ + "img/sms.07d294ad.svg";